import React, { useState } from 'react'
import Container from 'components/Container'
import { getSigner } from 'utils'
import NumericalInput from 'components/NumericalInput'
import { Button } from '@pancakeswap-libs/uikit'
import { RowBetween } from 'components/Row'
import Countdown from 'react-countdown'
import copy from 'copy-to-clipboard';
import useToast from 'hooks/useToast'
import BigNumber from 'bignumber.js'

import { Contract } from 'ethers'
import { Lock } from 'data/Lock'
import { MaxUint256 } from '@ethersproject/constants'
import { useTranslation } from 'react-i18next'
import AppBody from '../AppBody'
import { Wrapper, EarningCountdown, CountdownContent, CountdownBox, EarningText, TokenPopItem, TokenPopBox, CardContent, LockInputBox, Icon, WarnTip, AddressBox, AddressTitle, AddressText, CopyIcon, LockBox, LockText, LockClickText,
  TabBox, TabItem, RecordBox, CommonText,
} from './styleds'
import Token_ABI from '../../constants/abis/erc20.json'
import { useActiveWeb3React } from '../../hooks'
// import { MEME } from '../../constants'
import { LockPlatformCoin } from '../../data/LockPlatformCoin'
import LOCK_ABI from '../../constants/abis/lock.json'
import copyImg from '../../assets/images/copy.png'
import downImg from '../../assets/images/down.png'
// import airImg from '../../assets/images/air.png'

export default function Airdrop({ match }) {
    const { lockAddress } = match.params
    const { account, chainId, library } = useActiveWeb3React()
    const { toastSuccess, toastError } = useToast()

    const [shopPop, setShopPop] = useState(false);
    const [selectToken, setSelectToken] = useState({
      symbol: '',
      tokenAddress: '',
      principal: '',
      decimals: 0,
      balance: 0,
      allowance: 0
    });
    
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [approveLoading, setApproveLoading] = useState(false); 
    const [lockLoading, setLockLoading] = useState(false);
    const [active, setActive] = useState(1);

    const { t } = useTranslation()
    
    const platformCoinSymbol = LockPlatformCoin(lockAddress)
    const { userInfo, userLocks, userSupportTokens, totalReward, reward, lockTime, userLockAmount }:any = Lock(lockAddress, account ?? undefined)

    const renderer = ({ hours, minutes, seconds }) => {
      return <CountdownContent><span>{hours}</span>小时<span>{minutes}</span>分钟<span>{seconds}</span>秒</CountdownContent>;
    };
    // const handleCopyMeme = () => {
    //   copy(MEME.address)
    //   toastSuccess(t('copy successfully'))
    // }
    const handleCopyLock = () => {
      copy(lockAddress)
      toastSuccess(t('copy successfully'))
    }
    const handleActive = value => {
      if(value === active) return
      setActive(value)
    }
    const handleInput = async value => {
      setAmount(value)
    };
    const handleReceive = async () => {
     
      if (!chainId || !library || !account) return
       setLoading(true)
       try {
         const contract = new Contract(lockAddress, LOCK_ABI,getSigner(library, account))
         const tx = await contract.withdrawReward()
         // eslint-disable-next-line no-console
        await tx.wait();
         setLoading(false)
         toastSuccess(t('Receive success'))
       } catch {
         setLoading(false)
         toastError(t('Receive Failed'))
       }
     }

     const handleApprove = async () => {
     
      if (!chainId || !library || !account) return
      setApproveLoading(true)
       try {
         const contract = new Contract(selectToken.tokenAddress, Token_ABI,getSigner(library, account))
         const tx = await contract.approve(lockAddress, MaxUint256)
         // eslint-disable-next-line no-console
        await tx.wait();
        setApproveLoading(false)
         toastSuccess(t('Approve successful'))
         setSelectToken(prev => ({
          ...prev,
          allowance: 115792089237316195423570985008687907853269984665640564039457584007913129639935
        }));
       } catch {
        setApproveLoading(false)
         toastError(t('Approve failed'))
       }
     }

     const handleLock = async () => {
     
      if (!chainId || !library || !account) return
      setLockLoading(true)
       try {
         const contract = new Contract(lockAddress, LOCK_ABI,getSigner(library, account))
         const num = new BigNumber(amount).multipliedBy(`${10 ** selectToken.decimals}`).toFixed()
         const tx = await contract.lockToken(selectToken.tokenAddress, num)
         // eslint-disable-next-line no-console
        await tx.wait();
        setLockLoading(false)
         toastSuccess(t('Successfully locked'))
         setSelectToken(prev => ({
          ...prev,
          balance: new BigNumber(prev.balance).minus(num).toNumber()
        }));
       } catch(err) {
        setLockLoading(false)
         toastError(t('Failed to locked'))
       }
     }

     const handleUnlock = async (address) => {
     
      if (!chainId || !library || !account) return
       try {
         const contract = new Contract(lockAddress, LOCK_ABI,getSigner(library, account))
         const tx = await contract.unLockToken(address)
         // eslint-disable-next-line no-console
        await tx.wait();
         toastSuccess(t('successful redemption'))
       } catch {
         toastError(t('redemption failed'))
       }
     }
   
     const handleClikItem =  (token:any) => {
      setShopPop(false)
      setSelectToken(token)
     }
     const handleShowPop =  () => {
      setShopPop(!shopPop)
     }
    return (
      <Container>
      <AppBody>
        <Wrapper>
            <WarnTip>
            { t('airDesc', { symbol: platformCoinSymbol }) }<br />
            { t('Please do not use your wallet to transfer money directly to the airdrop contract address.') }
            </WarnTip>
          <CardContent>
             <AddressBox>
               <AddressTitle>{ t('Airdrop contract address') }</AddressTitle>
               <RowBetween>
                 <AddressText>{ lockAddress }</AddressText>
                 <CopyIcon src={ copyImg } size='15px' onClick={handleCopyLock}/>
               </RowBetween>  
             </AddressBox>
             {/* <AddressBox>
               <AddressTitle>{ t('MEME contract address') }</AddressTitle>
               <RowBetween>
                 <AddressText>{ MEME.address }</AddressText>
                 <CopyIcon src={ copyImg } size='15px' onClick={ handleCopyMeme } />
               </RowBetween>  
             </AddressBox> */}
              <LockBox>
                <RowBetween align='top'>
                  <LockText>{ t('Locked') }:</LockText>
                  <div>
                { userLocks?.length > 0 ? (
                <>
                  {userLocks.map((item) => (
                    <RowBetween  key={ item.tokenAddress } style={{ marginBottom: '10px' }}>
                    <LockText style={{ marginRight: '15px' }}>{ new BigNumber(item.amount).dividedBy(`${10 ** item.decimals}`).toFixed(3) } { item.symbol }({ t('Lock')}){ item.isSupport ? '' : `(${t('not online')})`}</LockText>
                    <LockClickText onClick={(event) => {
                      event.stopPropagation()
                       handleUnlock(item.tokenAddress)
                    }}>{ t('Redemption') }</LockClickText>
                  </RowBetween>
                  ))}
                </>
              ) : (
                <LockClickText>0.000</LockClickText>
              )}
            </div>
                </RowBetween> 
                <RowBetween marginTop='10px'>
                  <LockText>{ t('Airdrop Rewards') }:</LockText>
                  <LockText>{ Number(totalReward/10**18).toFixed(3) } {platformCoinSymbol}</LockText>
                </RowBetween> 
                <RowBetween marginTop='10px'>
                  <LockText>{ t('Effective lockup quantity') }:</LockText>
                  <LockText>{ userLockAmount ? Number(userLockAmount/10**18).toFixed(3) : '0.000'} {platformCoinSymbol}</LockText>
                </RowBetween>
              </LockBox>
              <Button onClick={ handleReceive } disabled={ loading } marginTop='5px' width="100%">{  loading ? `${t('Receive')}...` : t('Receive') }</Button>
             <LockBox style={{ marginTop: '20px' }}>
              <RowBetween marginBottom='10px'>
                <LockText>{ t('Lock up') }</LockText>
                <LockText>{ t('Balance') }:{ Number(selectToken?.balance / 10 ** selectToken?.decimals).toFixed(3) || '0.000' } { selectToken?.symbol || '' }</LockText>
              </RowBetween>
              <LockInputBox>
              <RowBetween>
                <NumericalInput style={{ flex: 1, display: 'block', marginRight: '5px' }} value={ amount } onUserInput={ handleInput } placeholder={ t('Please enter the quantity') } />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LockText style={{ marginRight: '5px' }} onClick={ handleShowPop }>{ selectToken?.symbol || t('select token') }</LockText>
                  <Icon src={ downImg } onClick={ handleShowPop } size='10px' />
                </div>
                </RowBetween>
                { shopPop ? (<TokenPopBox>
                  
                  { userSupportTokens?.length > 0 ? (
                <>
                  {userSupportTokens.map((item) => (
                    <TokenPopItem key={item.tokenAddress + item.symbol} onClick={(event) => {
                      event.stopPropagation()
                       handleClikItem(item)
                    }} className={ item.tokenAddress === selectToken.tokenAddress ? 'active' : ''}>
                      { item.symbol }
                  </TokenPopItem>
                  ))}
                </>
              ) : (
                <></>
              )}
                </TokenPopBox>) :
                  (<></>)
                }
              </LockInputBox>
             </LockBox>
             
             {!selectToken.symbol ? (
                <Button disabled width="100%">{ t('Please select a token') }</Button>
              ) : !amount ? (
                <Button disabled width="100%">{ t('Please enter the token amount') }</Button>
              ): Number(selectToken.balance/10** selectToken.decimals) < Number(amount) ?
              (<Button disabled width="100%">{ t('Insufficient token balance') }</Button>) :
              Number(selectToken.allowance/10** selectToken.decimals) < Number(amount) ?
              (
                <Button width="100%" disabled={ approveLoading } onClick={ handleApprove }>{ approveLoading ? `${t('Approve')}...` : `${t('Approve')} ${selectToken.symbol}`} </Button>
              ) :
              (
                <Button width="100%" disabled={ lockLoading } onClick={ handleLock }>{ lockLoading ? `${ t('Lock up immediately') }...` : t('Lock up immediately')}</Button>
              )}
             { Number(reward) === 0 && userInfo && Number(userInfo.reward) > 0 ? (<EarningCountdown>
                <CountdownBox>
                  <Countdown daysInHours date={ Number(userInfo.lastTime * 1000) +  lockTime * 1000} renderer={ renderer }/>
                </CountdownBox>
                <EarningText>{ t('can be unlocked later') } { Number(userInfo.reward/100/10**18).toFixed(3) } {platformCoinSymbol}</EarningText>
              </EarningCountdown>) : (
                <></>
              ) }
          </CardContent>
        </Wrapper>
      </AppBody>
      {/* <AirIconBox>
        <AirIcon src={ airImg } width='167px' height='163px' />
      </AirIconBox> */}
      {/* <AppBody>
        <Wrapper>
        <TabBox>
          <RowBetween>
            <TabItem className={ Number(active) === 1 ? 'active' : ''} onClick={(event) => {
                  event.stopPropagation()
                  handleActive(1)
              }}>{ t('Code') }</TabItem>
            <TabItem className={ Number(active) === 2 ? 'active' : ''} onClick={(event) => {
                  event.stopPropagation()
                  handleActive(2)
              }}>{ t('Permission drop') }</TabItem>
          </RowBetween>
         </TabBox>
         { active === 1 ? (<RecordBox>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Airdrop contract open source code viewing link') }</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>https://bscscan.com/block/0xb11a806ce8e5f07618a563e74e8c9572e7c23a797638bd6f63c41822095ac7b</CommonText>
         </RecordBox>) : <></> }
         { active === 2 ? (<RecordBox>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Airdrop contract permission drop view link') }</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>https://bscscan.com/block/0xb11a806ce8e5f07618a563e74e8c9572e7c23a797638bd6f63c41822095ac7b</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Airdrop contract address') }:</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>0xb11a806ce8e5f07618a563e74e8c9572e7c23a</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Airdrop contract permissions discard hash records') }</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>https://bscscan.com/block/0xb11a806ce8e5f07618a563e74e8c9572e7c23a797638bd6f63c41822095ac7b</CommonText>
         </RecordBox>) : <></> }
        </Wrapper>
      </AppBody> */}
    </Container>
    )
  }